import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

import { IPopupComponent } from '../interfaces/popup.interface';
import { PopupComponent } from '../popup.component';
import { IPopupOptions } from '../interfaces/popup-options.interface';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class PopupService {
    private popupsOptions: any[] = [];
    constructor(public matDialog: MatDialog) {}
    public open(
        component: ComponentType<IPopupComponent>,
        config: IPopupOptions
    ) {

        
       // { disableClose: true }
        if (
            !config.openPopupMultiTimes &&
            this.popupsOptions.find((opt) => opt.title == config.title)
        ) {

            throw Error('the popup already opened');
        }
        else {

            //  PopupId should be added to all popups

            const matConfig: MatDialogConfig = {
                disableClose: true /*data:config*/,
            };
            const options = {
                externalComponent: component,
                ...config,
                close: () => { }

            }
            this.addOptions(options);
            const dialog = this.matDialog.open(PopupComponent, matConfig)
            options.close = () => {
                dialog.close();
                this.removeOptions();
            }

            return dialog.afterClosed();
        }
    }
    private addOptions(options: any): void {
        this.popupsOptions = [...this.popupsOptions, options];
    }

    public get popupOptions(): any {
        return this.popupsOptions[this.popupsOptions.length - 1];
    }
    public removeOptions(): void {
        const removedOption = this.popupsOptions[this.popupsOptions?.length - 1];
        this.popupsOptions.length = this.popupsOptions && this.popupsOptions.length > 0 ? this.popupsOptions?.length - 1 : 0;
        return removedOption?.status;
    }


}
